module.exports = __webpack_public_path__ + "img/security_comm_fault_off.f6cb2540.svg";